import { Popover as PopoverComponent } from 'antd';
import { FC, ReactNode } from 'react';
import { TooltipPlacement } from 'antd/es/tooltip';
import classNames from 'classnames';
import { isMobile } from 'react-device-detect';

import './index.scss';

type PopoverProps = {
	content: string | JSX.Element;
	trigger?: string;
	placement?: TooltipPlacement;
	children: ReactNode;
	zIndex?: number;
	className?: string;
	isButton?: boolean;
};

export const Popover: FC<PopoverProps> = ({
	content,
	trigger = 'hover',
	children,
	placement = 'top',
	zIndex,
	className,
	isButton,
}) => {
	return (
		<>
			{isMobile && isButton ? (
				children
			) : (
				<PopoverComponent
					content={content}
					trigger={isMobile ? 'click' : trigger}
					overlayClassName={classNames('popover', { [`${className}`]: className })}
					placement={isMobile ? 'topRight' : placement}
					zIndex={zIndex}
				>
					{children}
				</PopoverComponent>
			)}
		</>
	);
};
